import { useEffect } from 'react'

export type LtiDeepLinkData = {
  url: string
  jwt: string
}

export function LtiAutoSubmittedForm({
  deepLinkData,
}: {
  deepLinkData: LtiDeepLinkData | undefined
}) {
  useEffect(() => {
    const autoSubmitLtiForm = () => {
      const form = document.getElementById('deep-link-form') as HTMLFormElement
      if (form) {
        form.submit()
        return true
      }
      return false
    }
    autoSubmitLtiForm()
  }, [deepLinkData])

  if (!deepLinkData) return null
  return (
    <form method="POST" id="deep-link-form" action={deepLinkData.url}>
      <input type="hidden" name="JWT" value={deepLinkData.jwt} />
    </form>
  )
}
